import { useGetAlertDecisionLabel } from "src/hooks/alerts/useGetAlertDecisionLabel";
import { useGetAlertStatusLabel } from "src/hooks/alerts/useGetAlertStatusLabel";
import { useFormatCurrency, useFormatDate, useT } from "src/internationalization";
import { Alert } from "src/types/alert";

import { WidgetProperty } from "../Widgets/Widget.typings";

import { PrintableProperties } from "./PrintableWidgetContainer";

export function PrintableAlertWorkflowWidget({ alert }: { alert: Alert }) {
  const statusLabel = useGetAlertStatusLabel();
  const t = useT();
  const decisionLabel = useGetAlertDecisionLabel();
  const formatDate = useFormatDate();
  const formatCurrency = useFormatCurrency();

  const properties: WidgetProperty[] = [
    { label: t("component.widget.alert.workflow.status"), value: statusLabel(alert.status) },
    {
      label: t("page.alerts.table.header.decision"),
      value: alert.decision ? decisionLabel(alert.decision) : t("page.alert.pdf.decision.pending"),
    },
    { label: t("page.alerts.table.header.assignee"), value: alert.assigneeFullName },
    {
      label: t("page.alert.pdf.rules.workflow.validation"),
      value: alert.validationDate
        ? formatDate(alert.validationDate, { dateStyle: "medium", timeStyle: "short" })
        : "—",
    },
    { label: t("page.alert.pdf.rules.workflow.validate"), value: alert.validatorFullName },
  ];
  if (alert.origin !== "manual")
    properties.push({ label: t("page.alert.pdf.workflow.score"), value: alert.globalScore });
  if (alert.fraudType) properties.push({ label: "Type de fraude", value: alert.fraudType });
  if (alert.financialLossAmount !== null)
    properties.push({
      label: t("page.alert.pdf.workflow.loss"),
      value: formatCurrency(alert.financialLossAmount),
    });
  if (alert.preventedFraudAmount !== null)
    properties.push({
      label: t("page.alert.pdf.workflow.preserve"),
      value: formatCurrency(alert.preventedFraudAmount),
    });
  return (
    <>
      <PrintableProperties properties={properties} />

      <h3 className="text-heading01 font-heading01 mt-5 mb-2">
        {t("page.alert.pdf.rules.workflow.comment")}
      </h3>
      <div className="printable-comment whitespace-pre-wrap">
        {alert.comment || t("page.alert.pdf.rules.workflow.comment.none")}.
      </div>
      <h3 className="text-heading01 font-heading01 mt-5 mb-2">
        {t("page.alert.pdf.rules.workflow.attachment")} ·{" "}
        {t("page.alert.pdf.rules.workflow.attachment.names")}
      </h3>
      {alert.attachments.length ? (
        <ol className="pdf-attachments list-decimal pl-5 mt-3">
          {alert.attachments.map((file) => (
            <li
              key={file.id}
              className="text-label01 py-2 pl-1 border-solid border-b-borderSubtle  border-b break-words"
            >
              {file.name}
            </li>
          ))}
        </ol>
      ) : (
        <div>{t("page.alert.pdf.rules.workflow.attachment.none")}.</div>
      )}
    </>
  );
}
